"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUserManageProjectSharing = void 0;
const consts_1 = require("~/store/account/consts");
function canUserModifyProject(user, project) {
    var _a;
    if (!project || !user) {
        return false;
    }
    if (project.permissions) {
        return project.permissions.edit === true;
    }
    const userType = (_a = user.userType) === null || _a === void 0 ? void 0 : _a.name;
    const userDistributorId = user.distributorId;
    if (project.user_id === user.id || userType === consts_1.UserRoles.admin) {
        return true;
    }
    if (userType === consts_1.UserRoles.customer) {
        return false;
    }
    if (userType === consts_1.UserRoles.distributor) {
        return userDistributorId != null && project.distributorId != null && project.distributorId === userDistributorId;
    }
    return false;
}
exports.default = canUserModifyProject;
function canUserManageProjectSharing(user, project) {
    if (!user || !project) {
        return false;
    }
    if (project.permissions) {
        return project.permissions.manageSharing === true;
    }
    return canUserModifyProject(user, project);
}
exports.canUserManageProjectSharing = canUserManageProjectSharing;
